import styled from 'styled-components';
import media from 'styles/media';

export const ReceivedHTML = styled.span`
  ul, li {
    list-style-type: none;
    margin: 15px 0;
    padding: 0;
    ${media.extraSmallAndBelow`
      margin: 0.5em 0;
    `};
  }
  
  .bulleted li {
    list-style-type: disc;
    margin-left: 1em;
  }
  
  .suggestion-box {
    padding: 20px 40px;
    background: #d9f4ff;
    ${media.extraSmallAndBelow`
      padding: 15px 30px;
  `}
  }
  
  em {
    font-style: normal;
    font-weight: bold;
    color: ${props => props.theme.urgentColor};
  }
  
  .consult-alert__heading-wrapper {
    padding: 20px 40px;
    margin: 0px -40px;
    background: ${props => props.theme.emergencyColor};
    ${media.extraSmallAndBelow`
      margin: -10px -13px;
      padding-left: 15px;
      padding-right: 15px;
    `}
        
    .consult-alert__heading { 
      ${media.extraSmallAndBelow`
        background-size: 40px;
        background-position: right 50px;
      `}
      margin: 0;
      color: white;
      line-height: 35px;
      font-size: 25px;
      font-family: sans-serif;
      font-weight: 300;
      
      ${media.extraSmallAndBelow`
        padding: 1px 0 15px;
        font-size: 19px;
        line-height: 30px;
      `}
      
      .sr-only {
        position: absolute;
        left: -10000px;
        overflow: hidden;
        height: 1px;
        width: 1px;
      }
    }
  }
  
  .consult-alert--urgent .consult-alert__heading-wrapper {
    background: ${props => props.theme.urgentColor};
  }
  
  .consult-alert__content {
    display: flex;
    flex-direction: column;
    ${media.extraSmallAndBelow`
      margin: -10px -13px;
      padding: 10px 15px 5px;
    `}
    
    p {
        margin-top: 40px;
    }
  }
  
  ul {
    margin-top: 1.5em;
    padding-left: 20px;
    list-style-type: disc;
    
    li {
      list-style-type: disc;
    }
  }
`;
